import moment from "moment";
import DatePicker from "react-datepicker";
import TimeInput from "time-input";

import BaseComponent from "../../../../baseComponent.js";
import InternalEvent from "../../../../../core/constants/internalEvent.js";
import Modal from "../../../../common/modal.jsx";
import styles from "./time-line-control.scss";
import React from "react";

export default class TimeLineControl extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: moment(),
      selectedTime: "00:00:00:000"
    }
  }

  componentWillReceiveProps() {
    this.setState({
      selectedDate: moment(),
      selectedTime: "00:00:00:000"
    });
  }

  componentDidMount() {
    // disable range selection
    this.input = document.querySelector(".TimeInput input");
    this.input.onmousemove = this.unFocus;
    this.input.onmouseup = this.unFocus;
  }

  unFocus() {
    const selection = window.getSelection();
    if (selection && selection.type === "Range") {
      window.getSelection().removeAllRanges()
    }
  }

  handleTimeChange(time) {
    this.setState({
      selectedTime: time
    });
  }

  handleDateChange(date) {
    this.setState({
      selectedDate: date
    });
  }

  confirm(e) {
    const time = this.state.selectedTime.split(":");
    const startDateString = this.state.selectedDate.format("YYYY-MM-DD");
    const startDateTime = moment(`${startDateString} ${time[0]}:${time[1]}:${time[2]}.${time[3]}`);
    this.publish(InternalEvent.Dashboard.SET_START_TIME, {
      widgetId: this.props.widget.id,
      startDateTime: startDateTime.valueOf()
    });
    this.refs.modal.hide();
  }

  show() {
    this.refs.modal.show();
  }

  render() {
    return (
      <Modal ref="modal" width={500} confirm={this.confirm} confirmLabel="go" cancelLabel="cancel">
        <h5>Go to</h5>
        <div className={styles.container}>
          <i className="material-icons">date_range</i>
          <DatePicker
            selected={this.state.selectedDate}
            maxDate={moment()}
            onChange={date => this.handleDateChange(date)}/>
          <i className="material-icons">access_time</i>
          <TimeInput value={this.state.selectedTime} onChange={time => this.handleTimeChange(time)}/>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/time-line-control/timeLineControl.jsx